/* eslint-disable */

(function ($) {
    $.widget('ep.single_line_record_input_field', $.ep.base_record_field, {
        options: {
            templateId: 'edit-record-single-line-field'
        },

        getData: function () {
            var value = $(".text_box", this.element).val();

            this._model.Value = value.length > 0 ? value : null;

            return this._model;
        },

        afterRenderTemplate: function () {
            this.setValidationRules();
        },

        setValidationRules: function () {
            $(".text_box", this.element).rules("add",
                {
                    required: this.options.model.Required,
                    messages: {
                        required: this.options.resources.validationRequired
                    }
                });

            if (this.options.model.isEmailRecordField) {
                $(".text_box", this.element).rules("add",
                {
                    email: true,
                    messages: {
                        email: this.options.resources.validationInvalidEmail
                    }
                });
            }
        },

        setValues: function() {
            $(".text_box", this.element).val(this._model.Value);
        }
    });
})(jQuery);

/* eslint-enable */